import type { Field, ReviewStatus } from '@/modules/Project/Fields/types'
import type { Property } from '@/modules/Project/Properties/types'
import { computed, type ComputedRef, type Ref } from 'vue'

/**
 * Returns the review status of a given field, taking into account whether the property is reviewable
 * and whether the field has a value.
 */
export const useFieldReviewStatus = (
  field: Ref<Field | undefined>,
  property: Ref<Property | undefined>,
): ComputedRef<ReviewStatus | null> =>
  computed(() => {
    const propertyIsNotReviewable = !property.value?.reviewable
    const fieldHasNoValue = !field.value?.toolValueUpdatedBy && !field.value?.manualValueUpdatedBy
    if (!field.value || propertyIsNotReviewable || fieldHasNoValue) {
      return null
    }

    return field.value.reviewStatus
  })
